import { configure } from 'axios-hooks';
import Axios from 'axios';

declare module 'axios' {}

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_INTERNET,
});

configure({ axios });

export default axios;
